export default __webpack_public_path__ + "locales/zh-CN/UploadPanel.json?hash=8960af16e1b99708e6906c074848355c";